import { useContext } from 'react';
import { BrandContext } from 'context/brand';
import type { Brand } from 'types/Brand';

export const useBrand = (): { brand: Brand | null } => {
  const { brand } = useContext(BrandContext);

  return { brand };
};
